import { Box, Grid } from "@mui/material";
import { StriimTypography } from "@striim/striim-ui-v2";
import React from "react";
import SidebarCollapse from "../../../../../../src/generic/icon/customIcons/sidebar_collapse.svg";
import { NodeIcon } from "../../nodes/node.commons";
import { useAppDispatch, useAppSelector } from "src/stores/redux/hooks";
import { getIsSidebarFullWidth } from "../../helpers/selectors";
import { toggleIsSidebarFullWidthAction } from "src/stores/redux/features/flowdesigner/flowdesigner.slice";
import { sxStyles } from "./sidebar.styles";

const FormTitle = ({ node, type, toggleFormType }) => {
    const dispatch = useAppDispatch();
    const isSidebarFullWidth = useAppSelector(getIsSidebarFullWidth);

    if (!node) return null;

    const handleSidebarCollapseClick = () => {
        dispatch(toggleIsSidebarFullWidthAction());
    };

    return (
        <Grid
            container
            alignItems={"center"}
            flexDirection={"row"}
            gap={1}
            p={2}
            justifyContent={"space-between"}
            borderLeft={"1px solid #e0e0e0"}
        >
            <Box display={"flex"} alignItems={"center"} gap={1} minWidth={0} flex={1}>
                <NodeIcon data={node.data} showBorder={true} />
                <StriimTypography
                    data-test-id="component-title"
                    variant="h2"
                    color="primary.700"
                    sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        userSelect: "text",
                        cursor: "text"
                    }}
                >
                    {node?.data?.name}
                </StriimTypography>
            </Box>
            <SidebarCollapse
                style={{
                    ...sxStyles.collapseIcon,
                    transform: isSidebarFullWidth ? "rotate(180deg)" : "none"
                }}
                onClick={handleSidebarCollapseClick}
                data-testid="toggle-fullscreen"
            />
        </Grid>
    );
};

export default FormTitle;
